import { Record } from 'immutable'

export class PaymentMethod extends Record({
    id: undefined,
    name: undefined,
}) {}
